var $6a0777ee77a74b18$exports = {};
$6a0777ee77a74b18$exports = {
    "(optional)": `(opcjonalne)`,
    "(required)": `(wymagane)`
};


export {$6a0777ee77a74b18$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
